import { socketCLient } from "./socketClient";
import { socketCLientSSL } from "./socketClientSSL.js";

const webSocketClient = () => {
    if (window.location.protocol === 'https:'){
        return socketCLientSSL;
    } else {
        return socketCLient;
    }
}
export default webSocketClient;